import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Input } from "./ui/input";
import { SYMBOLS } from "../lib/currency";
import { Coins } from "lucide-react";

export default function CurrencySwitcher({ currency }) {
  const { cur, setCode, setRate, symbol } = currency;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="flex items-center gap-1.5 rounded-xl border border-white/10 bg-white/[0.03] px-3 py-2 text-sm text-white hover:bg-white/[0.07] transition-colors">
          <Coins className="h-4 w-4 text-muted-foreground" />
          <span className="text-muted-foreground">MAD</span>
          <span className="text-muted-foreground">/</span>
          <span className="font-semibold text-brand-red">{symbol}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-64 glass-strong border-white/10">
        <p className="text-xs font-medium text-white">Display currency</p>
        <div className="mt-2 flex gap-2">
          {["GBP", "EUR", "USD"].map((code) => (
            <button key={code} onClick={() => setCode(code)}
              className={`flex-1 rounded-lg border py-2 text-sm font-medium transition-colors ${cur.code === code ? "border-brand-red bg-brand-red/15 text-brand-red" : "border-white/10 text-muted-foreground hover:text-white"}`}>
              {SYMBOLS[code]} {code}
            </button>
          ))}
        </div>
        <p className="mt-4 text-xs font-medium text-white">Exchange rates <span className="text-muted-foreground">(MAD per unit)</span></p>
        <div className="mt-2 space-y-2">
          {["GBP", "EUR", "USD"].map((code) => (
            <div key={code} className="flex items-center justify-between gap-2">
              <span className="text-sm text-muted-foreground">1 {SYMBOLS[code]} {code} =</span>
              <div className="flex items-center gap-1">
                <Input type="number" step="0.1" value={cur.rates[code]} onChange={(e) => setRate(code, e.target.value)}
                  className="h-9 w-24 bg-input/60 border-white/10 focus-visible:ring-brand-red text-right" />
                <span className="text-xs text-muted-foreground">MAD</span>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-3 text-[10px] text-muted-foreground">Saved on this device. Edit anytime.</p>
      </PopoverContent>
    </Popover>
  );
}
